var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('p',[_vm._v("Dashboard Coming Soon...")]),_c('p',{staticStyle:{"margin-top":"100px"}},[_c('i',{staticClass:"iconfont icon-working",staticStyle:{"font-size":"48px","color":"#409EFF"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }